import { BaseError } from '@dynamic-labs-sdk/client';

export class SponsorTransactionError extends BaseError {
  constructor(cause?: Error | null) {
    super({
      cause: cause ?? null,
      code: 'sponsor_transaction_error',
      docsUrl: null,
      name: 'SponsorTransactionError',
      shortMessage: 'Failed to sponsor transaction',
    });
  }
}
